import styled from '@emotion/styled';
import { Button } from '@mui/material';

export const StyledButton = styled(Button)`
  box-shadow: none;
  font-family: Rubik;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  padding: 8px 16px;
  text-transform: none;
`;
